import z from 'zod';

export const UserInformationSchema = z.object({
    userId: z.string(),
    userName: z.string(),
    userEmail: z.string(),
});

export type UserInformation = z.infer<typeof UserInformationSchema>;
